import { render } from "./ProductTabs.vue?vue&type=template&id=8173257e&scoped=true"
import script from "./ProductTabs.vue?vue&type=script&lang=js"
export * from "./ProductTabs.vue?vue&type=script&lang=js"

import "./ProductTabs.vue?vue&type=style&index=0&id=8173257e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8173257e"]])

export default __exports__